/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Release_NotesInputs */

const en_release_notes = /** @type {(inputs: Release_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release Notes`)
};

const fr_release_notes = /** @type {(inputs: Release_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes de version`)
};

const de_release_notes = /** @type {(inputs: Release_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versionshinweise`)
};

const it_release_notes = /** @type {(inputs: Release_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note di rilascio`)
};

const ru_release_notes = /** @type {(inputs: Release_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Примечания к выпуску`)
};

const es_release_notes = /** @type {(inputs: Release_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas de la versión`)
};

const zh_cn2_release_notes = /** @type {(inputs: Release_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发行说明`)
};

const ja_release_notes = /** @type {(inputs: Release_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リリースノート`)
};

const hi_release_notes = /** @type {(inputs: Release_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिलीज नोट्स`)
};

const pt_pt2_release_notes = /** @type {(inputs: Release_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas de lançamento`)
};

/**
* | output |
* | --- |
* | "Release Notes" |
*
* @param {Release_NotesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const release_notes = /** @type {((inputs?: Release_NotesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Release_NotesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_release_notes(inputs)
	if (locale === "de") return de_release_notes(inputs)
	if (locale === "it") return it_release_notes(inputs)
	if (locale === "ru") return ru_release_notes(inputs)
	if (locale === "es") return es_release_notes(inputs)
	if (locale === "zh-CN") return zh_cn2_release_notes(inputs)
	if (locale === "ja") return ja_release_notes(inputs)
	if (locale === "hi") return hi_release_notes(inputs)
	if (locale === "pt-PT") return pt_pt2_release_notes(inputs)
	return en_release_notes(inputs)
});